import React, { useEffect, useState } from "react";
import { Container, Nav, NavItem, NavLink, Form, CardBody } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import CustomCard from "../../../../Component/BasicComponents/Card/CustomCard";
import ReusableDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import {
  useAddOrUpdateModuleWiseConfiguration,
  useAutoCalculatedTa,
  useExpenseReminder,
  useModuleWiseConfiguration,
  usePaymentSystem,
  useTripApprovalRule,
  useWhenCanEmployeeSubmitExpenses,
  useWhenCanExpensesBooked,
  useYesOrNo,
} from "../hooks/useConfiguration";

const FormWithTabs = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [formValues, setFormValues] = useState<any>({});
  const tabs = [
    "Expense Management",
    "Trip Management",
    "Geo Locations",
    "Working Pattern",
  ];

  const { data: WhenCanEmployeeSubmitExpenses } =
    useWhenCanEmployeeSubmitExpenses({ enable: true });
  const { data: ExpenseReminder } = useExpenseReminder({ enable: true });
  const { data: TripApprovalRule } = useTripApprovalRule({ enable: true });
  const { data: WhenCanExpensesBooked } = useWhenCanExpensesBooked({
    enable: true,
  });
  const { data: PaymentSystem } = usePaymentSystem({ enable: true });
  const { data: YesOrNo } = useYesOrNo({ enable: true });
  const { data: AutoCalculatedTa } = useAutoCalculatedTa({ enable: true });
  const { data: ModuleWiseConfiguration } = useModuleWiseConfiguration({
    enable: true,
    id: activeTab,
  });
  const { mutate: addOrUpdateModuleWiseConfiguration } =
    useAddOrUpdateModuleWiseConfiguration();
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const submittedData = {
      id: activeTab,
      body: {},
    };

    if (activeTab === 1) {
      submittedData.body = {
        currentmonthsubmit: formValues.WhenCanEmployeeSubmitExpenses,
        paymentsystem: formValues.PaymentSystem,
        ExpenseAllowedMonths: formValues.ExpenseAllowedMonths,
        expense_reminder: formValues.ExpenseReminder,
        auto_settle: formValues.YesOrNo,
        expenseonlyontrip: formValues.WhenCanExpensesBooked,
        auto_calculated_ta: formValues.AutoCalculatedTa,
      };
    } else if (activeTab === 2) {
      submittedData.body = {
        TripApprovalRule: formValues.TripApprovalRule,
        Allowbackdatedtrip: formValues.Allowbackdatedtrip,
      };
    } else if (activeTab === 3) {
      submittedData.body = {
        AllowRadiusInMeter: formValues.AllowRadiusInMeter,
        GoogleMapApiKey: formValues.GoogleMapApiKey,
      };
    } else if (activeTab === 4) {
      submittedData.body = {
        WorkingDaysInWeek: formValues.WorkingDaysInWeek,
        ReportingDays: formValues.ReportingDays,
        JointWorkingDays: formValues.JointWorkingDays,
      };
    }
    if (ModuleWiseConfiguration?.data) {
      console.log("Updating Data:", submittedData);
    } else {
      console.log("Adding Data:", submittedData);
    }

    console.log("Submitting Data:", submittedData);
    addOrUpdateModuleWiseConfiguration(submittedData, {
      onSuccess: () => {
        console.log("ModuleWiseConfiguration submitted successfully!");
      },
      onError: (error) => {
        console.error("Error in ModuleWiseConfiguration:", error);
      },
    });
  };

  let formattedData = Object.entries(
    WhenCanEmployeeSubmitExpenses?.data || {}
  ).map((item: any) => ({
    id: item[0],
    label: item[1],
  }));
  let tripApprovalRuleData = Object.entries(TripApprovalRule?.data || {}).map(
    (item: any) => ({
      id: item[0],
      label: item[1],
    })
  );
  let expensesBookedData = Object.entries(
    WhenCanExpensesBooked?.data || {}
  ).map((item: any) => ({
    id: item[0],
    label: item[1],
  }));
  let yesOrNoData = Object.entries(YesOrNo?.data || {}).map((item: any) => ({
    id: item[0],
    label: item[1],
  }));
  let paymentSystemData = Object.entries(PaymentSystem?.data || {}).map(
    (item: any) => ({
      id: item[0],
      label: item[1],
    })
  );
  let autoCalculatedTaData = Object.entries(AutoCalculatedTa?.data || {}).map(
    (item: any) => ({
      id: item[0],
      label: item[1],
    })
  );
  const expenseReminderOptions = Array.isArray(ExpenseReminder?.data)
    ? ExpenseReminder?.data?.map((item: any, index: number) => ({
        id: index.toString(),
        label: item,
      }))
    : [];
  useEffect(() => {
    if (ModuleWiseConfiguration?.data) {
      const apiData = ModuleWiseConfiguration.data;
      console.log('apiData',apiData);
      

      if (activeTab === 1) {
        setFormValues({
          WhenCanEmployeeSubmitExpenses:
          apiData?.currentmonthsubmit?.toString() || "",
          PaymentSystem: apiData?.paymentsystem?.toString() || "",
          ExpenseReminder: apiData?.expense_reminder?.toString() || "",
          YesOrNo: apiData?.auto_settle?.toString() || "",
          WhenCanExpensesBooked: apiData?.expenseonlyontrip?.toString() || "",
          AutoCalculatedTa: apiData?.auto_calculated_ta?.toString() || "",
          ExpenseAllowedMonths:apiData?.ExpenseMonths?.toString() || "",
        });
      } else if (activeTab === 2) {
        setFormValues({
          TripApprovalRule: apiData?.tripapprovalreq?.toString() || "",
          Allowbackdatedtrip: apiData?.allowbackdatedtrip?.toString() || "",
        });
      } else if (activeTab === 3) {
        setFormValues({
          AllowRadiusInMeter: apiData?.allowradius?.toString() || "",
          GoogleMapApiKey: apiData?.googlemapkey?.toString() || "",
        });
      } else if (activeTab === 4) {
        setFormValues({
          WorkingDaysInWeek: apiData?.workingdaysinweek?.toString() || "",
          ReportingDays: apiData?.reporting_days?.toString() || "",
          JointWorkingDays: apiData?.jw_days?.toString() || "",
        });
      }
    } else {
      setFormValues({});
    }
  }, [ModuleWiseConfiguration, activeTab]);

  const handleTabChange = (index: number) => {
    setActiveTab(index + 1);
  };
  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));
  };

  return (
    <CustomCard
      style={{ width: "100%",padding:15 }}
      title="Module-wise Categorization"
      spanData={[
        { text: "Configure details for each module to streamline management." },
      ]}
      content={
        <Container className="p-0">
          <Nav
            pills
            style={{
              backgroundColor: "#ecf8f7",
              borderRadius: "8px",
              padding: "0px",
            }}
          >
            {tabs.map((tab, index) => (
              <NavItem key={index} style={{ flex: 1 }}>
                <NavLink
                  className={index + 1 === activeTab ? "active" : ""}
                  onClick={() => handleTabChange(index)}
                  style={{
                    cursor: "pointer",
                    textAlign: "center",
                    color: index + 1 === activeTab ? "#fff" : "#43b9b2",
                    backgroundColor:
                      index + 1 === activeTab ? "#43b9b2" : "transparent",
                    borderRadius: "5px",
                    padding: "14px 20px",
                  }}
                >
                  {tab}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          <CardBody className="p-0">
            <Form>
              {activeTab === 1 && (
                <>
                  <div className="row mt-3">
                    <div className="col-md-4">
                      <ReusableDropdown
                        options={formattedData || []}
                        value={formValues.WhenCanEmployeeSubmitExpenses}
                        // value={formValues.grade || selectedRowData?.GradeId}
                        onChange={(value: any) => {
                          handleDropdownSelect(
                            "WhenCanEmployeeSubmitExpenses",
                            value
                          );
                        }}
                        DropdownHeading="When Can Employees Submit Expenses"
                      />
                    </div>
                    <div className="col-md-4">
                      <ReusableDropdown
                        options={paymentSystemData || []}
                        value={formValues.PaymentSystem}
                        onChange={(value: any) => {
                          handleDropdownSelect("PaymentSystem", value);
                        }}
                        DropdownHeading="Payment System"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Expense Allowed Months
                      </label>
                      <input
                        className="form-control"
                        type="number"
                        name="ExpenseAllowedMonths"
                        value={formValues?.ExpenseAllowedMonths || ""}
                        onChange={(e) =>
                          setFormValues((prevState: any) => ({
                            ...prevState,
                            ExpenseAllowedMonths: e.target.value,
                          }))
                        }
                        required
                        style={{
                          border: "2px solid #EDEDED",
                          borderRadius: "8px",
                          padding: "13px",
                          fontSize: "14px",
                          width: "100%",
                          backgroundColor:'#fff'
                        }}
                      />
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-md-4">
                      <ReusableDropdown
                        options={expenseReminderOptions || []}
                        value={formValues.ExpenseReminder}
                        onChange={(value: any) => {
                          handleDropdownSelect("ExpenseReminder", value);
                        }}
                        DropdownHeading="Expense Reminder"
                      />
                    </div>
                    <div className="col-md-4">
                      <ReusableDropdown
                        options={yesOrNoData || []}
                        value={formValues.YesOrNo}
                        onChange={(value: any) => {
                          handleDropdownSelect("YesOrNo", value);
                        }}
                        DropdownHeading="Auto settle on approve ?"
                      />
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-md-4">
                      <ReusableDropdown
                        options={expensesBookedData || []}
                        value={formValues.WhenCanExpensesBooked}
                        onChange={(value: any) => {
                          handleDropdownSelect("WhenCanExpensesBooked", value);
                        }}
                        DropdownHeading="When Can Expenses be Booked"
                      />
                    </div>
                    <div className="col-md-4">
                      <ReusableDropdown
                        options={autoCalculatedTaData || []}
                        value={formValues.AutoCalculatedTa}
                        onChange={(value: any) => {
                          handleDropdownSelect("AutoCalculatedTa", value);
                        }}
                        DropdownHeading="Auto Calculated Ta"
                      />
                    </div>
                  </div>
                </>
              )}
              {activeTab === 2 && (
                <div className="row mt-3">
                  <div className="col-md-4">
                    <ReusableDropdown
                      options={tripApprovalRuleData || []}
                      value={formValues.TripApprovalRule}
                      onChange={(value: any) => {
                        handleDropdownSelect("TripApprovalRule", value);
                      }}
                      DropdownHeading="Trip Approval Rule"
                    />
                  </div>
                  <div className="col-md-4">
                    <ReusableDropdown
                      options={yesOrNoData || []}
                      value={formValues.Allowbackdatedtrip} // Use correct state value
                      onChange={(value: any) => {
                        handleDropdownSelect("Allowbackdatedtrip", value); // Update Allowbackdatedtrip
                      }}
                      DropdownHeading="Allow back dated trip ?"
                    />
                  </div>
                </div>
              )}
              {activeTab === 3 && (
                <div className="row mt-3">
                  <div className="col-md-4">
                    <label className="form-label">Allow Radius in Meter</label>
                    <input
                      className="form-control"
                      type="number"
                      name="AllowRadiusInMeter"
                      value={formValues?.AllowRadiusInMeter || ""}
                      onChange={(e) =>
                        setFormValues((prevState: any) => ({
                          ...prevState,
                          AllowRadiusInMeter: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Google Map Api Key</label>
                    <input
                      className="form-control"
                      type="text"
                      name="GoogleMapApiKey"
                      value={formValues?.GoogleMapApiKey || ""}
                      onChange={(e) =>
                        setFormValues((prevState: any) => ({
                          ...prevState,
                          GoogleMapApiKey: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                </div>
              )}
              {activeTab === 4 && (
                <div className="row mt-3">
                  <div className="col-md-4">
                    <label className="form-label">Working Days In Week</label>
                    <input
                      className="form-control"
                      type="number"
                      name="WorkingDaysInWeek"
                      value={formValues?.WorkingDaysInWeek || ""}
                      onChange={(e) =>
                        setFormValues((prevState: any) => ({
                          ...prevState,
                          WorkingDaysInWeek: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Reporting Days</label>
                    <input
                      className="form-control"
                      type="number"
                      name="ReportingDays"
                      value={formValues?.ReportingDays || ""}
                      onChange={(e) =>
                        setFormValues((prevState: any) => ({
                          ...prevState,
                          ReportingDays: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Joint Working Days</label>
                    <input
                      className="form-control"
                      type="number"
                      name="JointWorkingDays"
                      value={formValues?.JointWorkingDays || ""}
                      onChange={(e) =>
                        setFormValues((prevState: any) => ({
                          ...prevState,
                          JointWorkingDays: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                </div>
              )}
            </Form>
            <div className="mt-4 d-flex gap-2">
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                onClick={handleSubmit}
              >
                Submit
              </Btn>
              <Btn type="button">Cancel</Btn>
            </div>
          </CardBody>
        </Container>
      }
    />
  );
};

export default FormWithTabs;
